import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/third-party analytics errors completely
if (process.env.NODE_ENV === 'development') {
  const hideErrorOverlay = () => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
    // Also try the iframe approach
    const iframes = document.querySelectorAll('iframe[style*="position: fixed"]');
    iframes.forEach(iframe => {
      if (iframe.src?.includes('overlay') || !iframe.src) {
        iframe.style.display = 'none';
      }
    });
  };

  // Intercept errors before they reach the overlay
  const originalWindowError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (source?.includes('posthog') || message?.includes('postMessage') || message?.includes('PerformanceServerTiming')) {
      hideErrorOverlay();
      return true; // Prevent default handling
    }
    if (originalWindowError) {
      return originalWindowError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Also catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || String(event.reason);
    if (message?.includes('posthog') || message?.includes('postMessage') || message?.includes('PerformanceServerTiming')) {
      event.preventDefault();
      hideErrorOverlay();
    }
  });

  // Periodically check and hide the overlay if it appears with PostHog errors
  setInterval(() => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay && overlay.style.display !== 'none') {
      const content = overlay.textContent || overlay.innerText || '';
      if (content.includes('posthog') || content.includes('postMessage') || content.includes('PerformanceServerTiming')) {
        overlay.style.display = 'none';
      }
    }
  }, 500);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
